import lang from 'lang.js';
import messages from './messages';

const Lang = new lang({
    messages,
    locale: 'ar',
    fallback: 'en'
});

export default Lang;
